import React from 'react';
import PropTypes from 'prop-types';

import iconChevronRight from '../../../../assets/svg/icon-chevron-right.svg';
import SearchResult from '../search-result/SearchResult';

const SearchResults = ({
  searchTerm,
  results,
  rootUrl,
  moneyFormat,
  instantNoResults,
  viewAllString,
  typeProductsTitle,
  typeArticlesTitle,
}) => {
  const {products, articles} = results;
  const totalResults = products.length + articles.length;

  const renderResultGrid = (type, src, title) => (
    <div className={`quick-search-results__section quick-search-results__section--${type}`}>
      <h3 className="quick-search-results__section-title h6">{title}</h3>
      <div className={`quick-search-results__grid quick-search-results__grid--${type}`}>
        {src.map((result) => (
          <SearchResult key={result.id} result={result} moneyFormat={moneyFormat} type={type} />
        ))}
      </div>
    </div>
  );

  return (
    <div className="quick-search-results">
      {totalResults < 1 && (
        <p>
          {instantNoResults} &lsquo;{searchTerm}&rsquo;.
        </p>
      )}

      {products.length >= 1 && renderResultGrid('products', products, typeProductsTitle)}

      {articles.length >= 1 && renderResultGrid('articles', articles, typeArticlesTitle)}

      <p className="quick-search-results__cta">
        <a href={`${rootUrl}/search?type=product&q=${searchTerm}`} className="btn btn--icon">
          <span dangerouslySetInnerHTML={{__html: iconChevronRight}} />
          {viewAllString}
        </a>
      </p>
    </div>
  );
};

const TypeQueryResult = {
  url: PropTypes.string,
  text: PropTypes.string,
  styled_text: PropTypes.string,
};

const TypeCoreResult = {
  id: PropTypes.number,
  url: PropTypes.string,
  title: PropTypes.string,
};

const TypeImageResult = {
  featured_image: PropTypes.shape({
    url: PropTypes.string,
    aspect_ratio: PropTypes.number,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
};

const TypeFormResult = {
  variants: PropTypes.array,
};

SearchResults.propTypes = {
  searchTerm: PropTypes.string,
  results: PropTypes.shape({
    queries: PropTypes.arrayOf(
      PropTypes.shape({
        ...TypeQueryResult,
      })
    ),
    products: PropTypes.arrayOf(
      PropTypes.shape({
        ...TypeCoreResult,
        ...TypeImageResult,
        ...TypeFormResult,
        price: PropTypes.string,
      })
    ),
    collections: PropTypes.arrayOf(
      PropTypes.shape({
        ...TypeCoreResult,
        ...TypeImageResult,
      })
    ),
    pages: PropTypes.arrayOf(
      PropTypes.shape({
        ...TypeCoreResult,
      })
    ),
    articles: PropTypes.arrayOf(
      PropTypes.shape({
        ...TypeCoreResult,
        ...TypeImageResult,
      })
    ),
  }).isRequired,
  rootUrl: PropTypes.string.isRequired,
  moneyFormat: PropTypes.string.isRequired,
  instantNoResults: PropTypes.string,
  typeProductsTitle: PropTypes.string,
  typeArticlesTitle: PropTypes.string,
  viewAllString: PropTypes.string,
};

export default SearchResults;
